import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79fb7e28"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-state"]
const _hoisted_2 = { class: "market-overlay__message" }
const _hoisted_3 = { key: 0 }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useLogInOut } from '@exchange/libs/auth/ui/src';
import { MarketState } from '@exchange/libs/market/service/src';

export interface TextObjFromLokalise {
  SUSPENDED?: string | { href: string; text: string };
  IN_MAINTENANCE?: string | { href: string; text: string };
  NEW?: string | { href: string; text: string };
  POST_ONLY?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketOverlay',
  props: {
  hasBeenAuthenticated: { type: Boolean, required: true },
  marketName: { type: String, required: false },
  marketState: { type: String as PropType<MarketState>, required: false },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });
const router = useRouter();
const { login } = useLogInOut();

const getTextFrom = (property: TextObjFromLokalise, marketState: MarketState | undefined) => {
  if (!marketState) {
    return undefined;
  }

  switch (marketState) {
    case MarketState.SUSPENDED:
      return property.SUSPENDED;
    case MarketState.IN_MAINTENANCE:
      return property.IN_MAINTENANCE;
    case MarketState.NEW:
      return property.NEW;
    case MarketState.POST_ONLY:
      return property.POST_ONLY;
    default:
      return undefined;
  }
};

const titles = computed(() => ({
  SUSPENDED: t('modules.market.suspended.overlay.title'),
  IN_MAINTENANCE: t('modules.market.inMaintenance.overlay.title'),
  NEW: props.marketName ? t('modules.market.new.overlay.title', { market: props.marketName }) : '',
  POST_ONLY: props.marketName ? t('modules.market.postOnly.overlay.title', { market: props.marketName }) : '',
}));
const title = computed(() => getTextFrom(titles.value, props.marketState));

const textWithoutLink = computed(() => {
  const texts = {
    SUSPENDED: t('modules.market.suspended.overlay.text'),
    IN_MAINTENANCE: t('modules.market.inMaintenance.overlay.text'),
    POST_ONLY: t('modules.market.postOnly.overlay.text'),
  };

  return getTextFrom(texts, props.marketState);
});
const showTextWithoutLink = computed(
  () => props.marketState === MarketState.SUSPENDED || props.marketState === MarketState.IN_MAINTENANCE || props.marketState === MarketState.POST_ONLY,
);

const textWithLinkPath = computed(() => {
  const textPaths = {
    NEW: 'modules.market.new.overlay.text',
  };

  return getTextFrom(textPaths, props.marketState);
});

const linkText = computed(() => {
  const linkTexts = {
    NEW: t('modules.market.new.overlay.inlineURLText'),
  };

  return getTextFrom(linkTexts, props.marketState);
});

const onLinkClick = () => {
  const inlineRoutes = {
    NEW: {
      hash: '#Deposit',
    },
  };

  if (props.hasBeenAuthenticated) {
    const route = props.marketState ? inlineRoutes[props.marketState] : undefined;

    if (!route) {
      return undefined;
    }

    return router.push(route);
  }

  return login();
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", {
    class: "market-overlay",
    "data-state": __props.marketState
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(title.value), 1),
      (showTextWithoutLink.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(textWithoutLink.value), 1))
        : (_openBlock(), _createBlock(_component_i18n_t, {
            key: 1,
            scope: "global",
            tag: "p",
            keypath: textWithLinkPath.value
          }, {
            inlineUrl: _withCtx(() => [
              _createVNode(_component_x_button, {
                class: "market-overlay__link",
                size: "text-like",
                variant: "link",
                text: linkText.value,
                onClick: onLinkClick
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["keypath"]))
    ])
  ], 8, _hoisted_1))
}
}

})